import { z } from 'zod'

export const MedicalRecordReviewType = z.enum(['REVIEW', 'VIEW'])
export type MedicalRecordReviewType = z.infer<typeof MedicalRecordReviewType>
